import { render } from "./App.vue?vue&type=template&id=433e21bf"
const script = {}

import "./App.vue?vue&type=style&index=0&id=433e21bf&lang=css"
script.render = render

export default script